export type { SocialButtonProps } from './SocialButton'
export { default as SocialButton, GoogleButton, FacebookButton } from './SocialButton'
